import { memo, ReactNode } from 'react';
import { Brand, DEFAULT_LOGOS } from './logos';
import { StyledAvatar } from './styled';

export type { Brand } from './logos';
export { PlusLogo, ClaudeLogo, ChatGPTLogo, PerplexityLogo, GrokLogo, OtherLogo } from './logos';

interface IBrandAvatarProps {
  brand: Brand;
  size?: 'sm' | 'md';
  logo?: ReactNode;
}

const BrandAvatar = ({ brand, size = 'md', logo }: IBrandAvatarProps) => (
  <StyledAvatar $brand={brand} $size={size}>
    {logo ?? DEFAULT_LOGOS[brand]}
  </StyledAvatar>
);

export default memo(BrandAvatar);
